import { gql } from '@apollo/client/core';
import React from 'react';
import { Image } from '..';

export default function CollectionLogo({ collection, height, width, style }) {
  if (!hasContent(collection)) return null;
  return (
    <Image src={collection?.logo?.url} height={height} width={width} trim />
  );
}

CollectionLogo.hasContent = hasContent;
function hasContent({ logo }) {
  return !!logo;
}

CollectionLogo.fragment = gql`
  fragment CollectionLogo on Collection {
    logo {
      # This doesn't matter because the URL is recalculated by Image component
      # This should replaced with sourceUrl when it returns a String
      url
    }
  }
`;
